import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import * as FiltersConfigActions from './filters-config.actions';
import {loadInitialConfig} from '../store/global.actions';
import {errorHappened} from '../app.types';
import {SegmentsClientService} from '../segment/segments-client.service';


@Injectable()
export class FiltersConfigEffects {

  loadBrands$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadInitialConfig),
      switchMap(() =>
        this.segmentsClient.getBrands()
          .pipe(
            map(data => FiltersConfigActions.brandsLoaded({data})),
            catchError(err => of(errorHappened({error: {message: err.message}})))
          ))
    );
  });
  loadCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadInitialConfig),
      switchMap(() =>
        this.segmentsClient.getCategories()
          .pipe(
            map(data => FiltersConfigActions.categoriesLoaded({data})),
            catchError(err => of(errorHappened({error: {message: err.message}})))
          ))
    );
  });
  loadSegmentMainTypes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadInitialConfig),
      switchMap(() =>
        this.segmentsClient.getSegmentMainTypes()
          .pipe(
            map(data => FiltersConfigActions.segmentMainTypesLoaded({data})),
            catchError(err => of(errorHappened({error: {message: err.message}})))
          ))
    );
  });
  loadSegmentSubTypes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadInitialConfig),
      switchMap(() =>
        this.segmentsClient.getSegmentSubTypes()
          .pipe(
            map(data => FiltersConfigActions.segmentSubTypesLoaded({data})),
            catchError(err => of(errorHappened({error: {message: err.message}})))
          ))
    );
  });
  loadSegmentAudienceTypes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadInitialConfig),
      switchMap(() =>
        this.segmentsClient.getSegmentAudienceTypes()
          .pipe(
            map(data => FiltersConfigActions.segmentAudienceTypesLoaded({data})),
            catchError(err => of(errorHappened({error: {message: err.message}})))
          ))
    );
  });


  constructor(private actions$: Actions, private segmentsClient: SegmentsClientService) {
  }
}
